import {
  Calendar,
  Check,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  CircleCheck,
  Clock,
  Crown,
  Delete,
  ExternalLink,
  FileText,
  Grid3x3,
  Info,
  Linkedin,
  Mail,
  Maximize2,
  Mic,
  MicOff,
  Minus,
  Pencil,
  Phone,
  PhoneOff,
  Pause,
  Play,
  Plus,
  Reply,
  RotateCcw,
  Sparkles,
  TriangleAlert,
  User,
  Volume2,
  X
} from "lucide-react"

const wrap = (Cmp) => (props) => <Cmp {...props} />

// lucide ships Mic/MicOff and Phone/PhoneOff pairs but no PauseOff, so the hold
// control had to swap to a Play glyph to show its active state — a different
// shape, which stops it reading as a hold button. This matches lucide's own
// geometry (24 viewBox, 2px round strokes, slash corner to corner) so the
// on-state of hold looks like the on-state of mute.
const PauseOff = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="10" y1="5" x2="10" y2="19" />
    <line x1="16" y1="5" x2="16" y2="19" />
    <line x1="2" y1="2" x2="22" y2="22" />
  </svg>
)

const I = {
  phone: wrap(Phone),
  phoneOff: wrap(PhoneOff),
  mic: wrap(Mic),
  micOff: wrap(MicOff),
  keypad: wrap(Grid3x3),
  volume: wrap(Volume2),
  user: wrap(User),
  close: wrap(X),
  minus: wrap(Minus),
  check: wrap(Check),
  checkCircle: wrap(CircleCheck),
  calendar: wrap(Calendar),
  reply: wrap(Reply),
  rotateCcw: wrap(RotateCcw),
  mail: wrap(Mail),
  sparkle: wrap(Sparkles),
  doc: wrap(FileText),
  chevR: wrap(ChevronRight),
  chevD: wrap(ChevronDown),
  chevronUp: wrap(ChevronUp),
  info: wrap(Info),
  alert: wrap(TriangleAlert),
  plus: wrap(Plus),
  pause: wrap(Pause),
  pauseOff: wrap(PauseOff),
  play: wrap(Play),
  clock: wrap(Clock),
  edit: wrap(Pencil),
  external: wrap(ExternalLink),
  crown: wrap(Crown),
  backspace: wrap(Delete),
  maximize: wrap(Maximize2),
  linkedin: wrap(Linkedin)
}

export default I
